module.exports = __webpack_public_path__ + "e85077b4f04bfb47eab5cd65d2127d37.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/sv.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/sv.svg
// module chunks = 0